import get from 'lodash.get';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import DepositLink from 'dibs-buyer-deposit/exports/DepositLink';
import DepositsAccepted from 'dibs-buyer-deposit/src/messages/DepositsAccepted';
import depositTracking from 'dibs-buyer-deposit/exports/depositTracking';

import { PdpSharedDepositModalLoader } from '../PdpSharedModals/PdpSharedDepositModal/PdpSharedDepositModalLoader';

import styles from './PdpSharedDeposit.scss';

class PdpSharedDepositComponent extends Component {
    constructor(props) {
        super(props);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.openModal = this.openModal.bind(this);

        this.state = {
            isModalOpen: false,
        };
    }

    handleModalClose() {
        depositTracking.trackClose();
        this.setState({ isModalOpen: false });
    }

    openModal() {
        this.setState({ isModalOpen: true });
    }

    render() {
        const { item, userId, relay } = this.props;
        const { isModalOpen } = this.state;
        const isDepositAvailable = get(item, 'isDepositAvailable');

        if (!userId || !isDepositAvailable) {
            return null;
        }

        return (
            <div className={styles.wrapper}>
                <DepositLink onClick={this.openModal} label={<DepositsAccepted />} />
                <PdpSharedDepositModalLoader
                    isOpen={isModalOpen}
                    itemId={item.serviceId}
                    buyerId={userId}
                    handleClose={this.handleModalClose}
                    environment={relay.environment}
                />
            </div>
        );
    }
}

PdpSharedDepositComponent.propTypes = {
    userId: PropTypes.string,
    item: PropTypes.object,
    relay: PropTypes.object,
};

export const PdpSharedDeposit = createFragmentContainer(PdpSharedDepositComponent, {
    item: graphql`
        fragment PdpSharedDeposit_item on Item {
            serviceId
            isDepositAvailable(buyerId: $userId)
        }
    `,
});
